import { View } from "react-native";
import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import OpacityView from "src/components/OpacityView";
import PillButton from "src/components/PillButton";
import UserBadge from "src/components/UserBadge";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useDevice from "src/hooks/useDevice";
import useRouter from "src/hooks/useRouter";
import IconClose from "src/icons/IconClose";
import IconLivePhoto from "src/icons/IconLivePhoto";
import { useModalContext } from "src/modals/contexts/ModalContext";
import useIsSettledPhotoCaughtUp from "src/screens/(internal)/PhotoDetailModal/hooks/useIsSettledPhotoCaughtUp";
import usePhotoDetailHeaderDimensions from "src/screens/(internal)/PhotoDetailModal/hooks/usePhotoDetailHeaderDimensions";
import usePhotoDetailStore from "src/screens/(internal)/PhotoDetailModal/stores/usePhotoDetailStore";
import { paddingMedium, paddingXL } from "src/styles/spacing";
import { AnimatePresence, useSafeArea } from "src/swsh-native";
import PhotoOptions from "../../../PhotoOptions";
import PhotoDetailStatus from "./components/PhotoDetailStatus";

const PhotoDetailHeader = () => {
	const identifier = useGatheringStore((state) => state.identifier);
	const router = useRouter();
	const photo = usePhotoDetailStore((state) => state.debouncedSettledPhoto);
	const isSettledPhotoCaughtUp = useIsSettledPhotoCaughtUp();
	const safeArea = useSafeArea();
	const { device } = useDevice();
	const { height, width } = usePhotoDetailHeaderDimensions();
	const modalContext = useModalContext();

	return (
		<View
			pointerEvents="box-none"
			style={{
				height,
				width,
				overflow: "hidden",
				flexDirection: "row",
				alignItems: "center",
				paddingTop: safeArea.top,
			}}
		>
			<View
				pointerEvents="box-none"
				style={{
					flex: 1,
					flexDirection: "row",
					alignItems: "center",
					marginLeft: paddingXL,
					marginRight: "auto",
					justifyContent: "flex-start",
				}}
			>
				<PillButton
					testID="PhotoDetailClose"
					opaque={device === "mobile"}
					Icon={IconClose}
					onPress={() => {
						if (identifier) {
							if (modalContext && modalContext.name) {
								modalContext.closeSelf();
							} else {
								router.backTo(`/album/${identifier}`);
							}
						} else {
							router.back();
						}
					}}
				/>
			</View>
			<UserBadge opaque userId={photo?.ownerId} testID="UploaderBadge" />
			<View
				// Ensuring people can't delete or report until things are settled
				// Shouldn't be an issue since things settle very quickly
				pointerEvents={isSettledPhotoCaughtUp ? "box-none" : "none"}
				style={{
					flex: 1,
					flexDirection: "row",
					alignItems: "center",
					marginLeft: "auto",
					marginRight: paddingXL,
					justifyContent: "flex-end",
					columnGap: paddingMedium,
				}}
			>
				<PhotoDetailStatus />
				{photo?.variant === PhotoVariant.LivePhoto && (
					<AnimatePresence>
						<OpacityView key="LivePhoto">
							<IconLivePhoto size={24} />
						</OpacityView>
					</AnimatePresence>
				)}
				<PhotoOptions />
			</View>
		</View>
	);
};

export default PhotoDetailHeader;
